<div class="banner" id="home">
  <div class="container">
    <div class="bannerSec row">
      <!-- ======= Banner Left Content ======= -->

      <div class="col-12 col-md-7 leftSec align-self-center">
        <div class="banner-content">
          <h1 class="banner-title">{{ 'banner.banner_text_1' | translate }}</h1>
          <h5 class="font-16 fw-regular banner-desc mt-3">{{ 'banner.banner_desc' | translate }}</h5>

          <div class="d-flex justify-content-center justify-content-md-start mb-3 pt-4 gap-3">
            <a class="px-4 btn btn-secondary" target="_blank" href="/assets/documents/ICO_Whitepaper.pdf"
              (click)="trackDocumentClick('whitepaper', '/assets/documents/ICO_Whitepaper.pdf')">
              <img src="/assets/images/svg-icons/whitepaper-icon.svg" alt="Whitepaper" loading="eager" />
              <span class="ps-2">{{ 'misc.whitepaper' | translate }}</span>
            </a>
            <a class="px-4 btn btn-primary" target="_blank" href="/assets/documents/ICO_Audit.pdf"
              (click)="trackDocumentClick('audit', '/assets/documents/ICO_Audit.pdf')">
              <img src="/assets/images/svg-icons/audit-icon.svg" alt="Audit" loading="eager" />
              <span class="ps-2">{{ 'misc.audit' | translate }}</span>
            </a>
          </div>
        </div>
      </div>
      <!-- ======= Widget goes here ======= -->
      <div class="col-12 col-md-5 align-self-center">
        <app-widget></app-widget>
      </div>
      <!-- ======= Widget goes here ======= -->
    </div>
  </div>
</div>